(function() {
  if (typeof customElements === 'undefined') return;
  if (customElements.get('scent-grid')) return;

  var N_VISIBLE = 5;

  var FAMILY_LABELS = {
    floral: 'Floral',
    citrus: 'Citrus',
    herbal: 'Herbal',
    sweet: 'Sweet',
    unscented: 'Unscented',
    'function': 'Purpose',
    other: 'Other'
  };

  var FAMILY_ORDER = ['floral', 'citrus', 'herbal', 'sweet', 'unscented', 'function', 'other'];

  function hashHue(str) {
    var h = 0;
    for (var i = 0; i < str.length; i++) {
      h = ((h << 5) - h) + str.charCodeAt(i);
      h = h & h;
    }
    return Math.abs(h) % 360;
  }

  function ScentGrid() {
    return Reflect.construct(HTMLElement, [], ScentGrid);
  }
  ScentGrid.prototype = Object.create(HTMLElement.prototype);
  ScentGrid.prototype.constructor = ScentGrid;
  Object.setPrototypeOf(ScentGrid, HTMLElement);

  ScentGrid.prototype.connectedCallback = function() {
    if (this.__inited) return;
    this.__inited = true;
    var self = this;
    requestAnimationFrame(function() {
      try { self.init(); }
      catch (e) {
        if (window && window.console) console.warn('[scent-grid] init failed:', e);
      }
    });
  };

  ScentGrid.prototype.init = function() {
    this.pills = this.collectPills();
    if (this.pills.length === 0) return;

    this.applyAlgorithmicDots();
    this.computeFamilyCounts();

    this.activeFamily = '_all';
    this.expanded = false;
    this.pickerOpen = false;

    // Move all existing children into a hidden picker container; insert summary row above.
    var existing = [];
    for (var ci = 0; ci < this.childNodes.length; ci++) {
      existing.push(this.childNodes[ci]);
    }
    this.picker = document.createElement('div');
    this.picker.setAttribute('data-scent-picker', '');
    this.picker.style.cssText = 'display:none;margin-top:10px;padding-top:10px;border-top:1px solid rgba(0,0,0,0.08);';
    for (var ei = 0; ei < existing.length; ei++) {
      this.picker.appendChild(existing[ei]);
    }

    this.summary = this.buildSummaryRow();
    this.appendChild(this.summary);
    this.appendChild(this.picker);

    if (this.shouldRenderFamilies()) {
      this.renderFamilyChips();
    }

    if (this.pills.length > N_VISIBLE) {
      this.renderMoreToggle();
    }

    this.bindSelectionSync();
    this.updateVisibility();
    this.syncSummary();
  };

  ScentGrid.prototype.buildSummaryRow = function() {
    // Use a real <button> so keyboard users (Enter/Space) can open the picker
    // — the previous <div> with only a click listener was inaccessible.
    var wrap = document.createElement('button');
    wrap.type = 'button';
    wrap.setAttribute('data-scent-summary', '');
    wrap.setAttribute('aria-expanded', 'false');
    wrap.setAttribute('aria-controls', '');
    wrap.style.cssText = 'display:flex;align-items:center;gap:10px;padding:10px 12px;border:1px solid rgba(0,0,0,0.18);border-radius:8px;cursor:pointer;font-family:inherit;background:transparent;color:inherit;text-align:left;width:100%;transition:border-color 0.15s, box-shadow 0.15s;';

    var label = document.createElement('span');
    label.style.cssText = 'opacity:0.6;font-size:13px;flex-shrink:0;';
    label.textContent = 'Scent:';

    var dot = document.createElement('span');
    dot.setAttribute('data-scent-summary-dot', '');
    dot.setAttribute('aria-hidden', 'true');
    dot.style.cssText = 'display:inline-block;width:11px;height:11px;border-radius:50%;background:#ccc;border:1px solid rgba(0,0,0,0.08);flex-shrink:0;';

    var name = document.createElement('span');
    name.setAttribute('data-scent-summary-name', '');
    name.style.cssText = 'font-weight:600;font-size:14px;flex-grow:1;line-height:1.3;';
    name.textContent = '—';

    var change = document.createElement('span');
    change.setAttribute('data-scent-change', '');
    change.style.cssText = 'font-size:12px;text-decoration:underline;opacity:0.7;flex-shrink:0;';
    change.textContent = 'Change';

    wrap.appendChild(label);
    wrap.appendChild(dot);
    wrap.appendChild(name);
    wrap.appendChild(change);

    var self = this;
    wrap.addEventListener('click', function() { self.togglePicker(); });
    wrap.addEventListener('mouseenter', function() {
      if (document.activeElement !== wrap) wrap.style.borderColor = 'rgba(0,0,0,0.4)';
    });
    wrap.addEventListener('mouseleave', function() {
      if (document.activeElement !== wrap) wrap.style.borderColor = 'rgba(0,0,0,0.18)';
    });
    wrap.addEventListener('focus', function() {
      wrap.style.borderColor = 'rgba(29, 52, 154, 0.9)';
      wrap.style.boxShadow = '0 0 0 2px rgba(29, 52, 154, 0.35)';
    });
    wrap.addEventListener('blur', function() {
      wrap.style.borderColor = 'rgba(0,0,0,0.18)';
      wrap.style.boxShadow = '';
    });

    return wrap;
  };

  ScentGrid.prototype.togglePicker = function() {
    this.pickerOpen = !this.pickerOpen;
    this.picker.style.display = this.pickerOpen ? '' : 'none';
    if (this.summary) {
      this.summary.setAttribute('aria-expanded', this.pickerOpen ? 'true' : 'false');
    }
    var changeEl = this.summary.querySelector('[data-scent-change]');
    if (changeEl) changeEl.textContent = this.pickerOpen ? 'Hide' : 'Change';
  };

  ScentGrid.prototype.syncSummary = function() {
    if (!this.summary) return;
    var selected = null;
    for (var i = 0; i < this.pills.length; i++) {
      if (this.pills[i].input.checked) {
        selected = this.pills[i];
        break;
      }
    }
    if (!selected) selected = this.pills[0];
    if (!selected) return;
    var nameEl = this.summary.querySelector('[data-scent-summary-name]');
    var dotEl = this.summary.querySelector('[data-scent-summary-dot]');
    if (nameEl) nameEl.textContent = selected.name;
    if (dotEl) {
      var inlineDot = selected.label.querySelector('[data-scent-dot]');
      if (inlineDot && inlineDot.style.background) {
        dotEl.style.background = inlineDot.style.background;
      }
    }
  };

  ScentGrid.prototype.collectPills = function() {
    var inputs = this.querySelectorAll('input[data-scent-pill]');
    var pills = [];
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var label = this.querySelector('label[for="' + input.id + '"]');
      if (!label) continue;
      var wrapper = this.findPillWrapper(input, label);
      pills.push({
        input: input,
        label: label,
        wrapper: wrapper,
        family: input.getAttribute('data-note-family') || 'other',
        name: input.getAttribute('data-scent-name') || input.value
      });
    }
    return pills;
  };

  ScentGrid.prototype.findPillWrapper = function(input, label) {
    // Climb until we find an ancestor that contains BOTH input and label, then return that wrapper.
    // If the input + label are sibling children of this scent-grid directly, the wrapper is the label.
    var parent = input.parentElement;
    while (parent && parent !== this) {
      if (parent.contains(label)) {
        // Don't return scent-grid itself
        if (parent === this) break;
        return parent;
      }
      parent = parent.parentElement;
    }
    // Fallback: just hide the label (the input is invisible anyway since it's a radio)
    return label;
  };

  ScentGrid.prototype.applyAlgorithmicDots = function() {
    for (var i = 0; i < this.pills.length; i++) {
      var label = this.pills[i].label;
      var name = this.pills[i].name;
      var dot = label.querySelector('[data-scent-dot]');
      if (!dot) continue;
      var bg = dot.style.background;
      if (!bg || bg.trim() === '' || bg === 'transparent') {
        var hue = hashHue(name);
        dot.style.background = 'hsl(' + hue + ', 35%, 65%)';
      }
    }
  };

  ScentGrid.prototype.computeFamilyCounts = function() {
    this.familyCounts = {};
    for (var i = 0; i < this.pills.length; i++) {
      var f = this.pills[i].family;
      this.familyCounts[f] = (this.familyCounts[f] || 0) + 1;
    }
    this.uniqueFamilies = Object.keys(this.familyCounts);
  };

  ScentGrid.prototype.shouldRenderFamilies = function() {
    return this.uniqueFamilies.length >= 2 && this.pills.length > 4;
  };

  ScentGrid.prototype.renderFamilyChips = function() {
    var wrap = document.createElement('div');
    wrap.className = 'scent-grid__families';
    wrap.style.cssText = 'display:flex;flex-wrap:wrap;gap:6px;margin:0 0 10px 0;';

    wrap.appendChild(this.makeChip('All', '_all', this.pills.length, true));

    for (var i = 0; i < FAMILY_ORDER.length; i++) {
      var f = FAMILY_ORDER[i];
      if (this.familyCounts[f]) {
        wrap.appendChild(this.makeChip(FAMILY_LABELS[f], f, this.familyCounts[f], false));
      }
    }

    this.picker.insertBefore(wrap, this.picker.firstChild);
    this.familyChipsEl = wrap;
  };

  ScentGrid.prototype.makeChip = function(label, family, count, isActive) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'scent-grid__chip';
    btn.setAttribute('data-family', family);
    btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    btn.innerHTML = label + ' <span style="opacity:0.7;font-size:0.9em;">' + count + '</span>';
    // Use distinct text color + border weight for active vs inactive rather
    // than opacity 0.5 (which fails WCAG AA against most backgrounds).
    var activeColor = '#1d349a';
    var inactiveColor = 'rgba(26, 24, 20, 0.7)';
    btn.style.cssText =
      'padding:6px 12px;border-radius:999px;background:transparent;cursor:pointer;font-size:12px;line-height:1.4;font-family:inherit;' +
      'border:1px solid ' + (isActive ? activeColor : 'rgba(26, 24, 20, 0.3)') + ';' +
      'color:' + (isActive ? activeColor : inactiveColor) + ';' +
      'font-weight:' + (isActive ? 700 : 500) + ';' +
      'transition:color 0.15s, border-color 0.15s, box-shadow 0.15s;';
    var self = this;
    btn.addEventListener('click', function() { self.setActiveFamily(family); });
    btn.addEventListener('focus', function() {
      btn.style.boxShadow = '0 0 0 2px rgba(29, 52, 154, 0.35)';
      btn.style.outline = 'none';
    });
    btn.addEventListener('blur', function() { btn.style.boxShadow = ''; });
    return btn;
  };

  ScentGrid.prototype.setActiveFamily = function(family) {
    this.activeFamily = family;
    if (this.familyChipsEl) {
      var activeColor = '#1d349a';
      var inactiveColor = 'rgba(26, 24, 20, 0.7)';
      var chips = this.familyChipsEl.querySelectorAll('.scent-grid__chip');
      for (var i = 0; i < chips.length; i++) {
        var isActive = chips[i].getAttribute('data-family') === family;
        chips[i].setAttribute('aria-pressed', isActive ? 'true' : 'false');
        chips[i].style.color = isActive ? activeColor : inactiveColor;
        chips[i].style.borderColor = isActive ? activeColor : 'rgba(26, 24, 20, 0.3)';
        chips[i].style.fontWeight = isActive ? '700' : '500';
      }
    }
    // Collapse to show only visible tier within the new family
    this.expanded = false;
    this.updateVisibility();
  };

  ScentGrid.prototype.renderMoreToggle = function() {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'scent-grid__more';
    btn.style.cssText = 'background:transparent;border:none;text-decoration:underline;cursor:pointer;font-size:13px;padding:6px 0;margin-top:4px;color:inherit;font-family:inherit;display:none;text-align:left;';
    var self = this;
    btn.addEventListener('click', function() {
      self.expanded = !self.expanded;
      self.updateVisibility();
    });
    this.picker.appendChild(btn);
    this.moreBtn = btn;
  };

  ScentGrid.prototype.bindSelectionSync = function() {
    var self = this;
    // Honor the user's reduced-motion preference — for those users the
    // 250ms auto-close is disorienting (screen readers especially).
    var prefersReducedMotion = false;
    try {
      prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) { /* old browser, ignore */ }

    for (var i = 0; i < this.pills.length; i++) {
      this.pills[i].input.addEventListener('change', function() {
        self.updateVisibility();
        self.syncSummary();
        if (self.pickerOpen && !prefersReducedMotion) {
          // Track the timeout id so disconnectedCallback can clear it. Without
          // this, swapping the variant-selects via product-info.js leaves the
          // timer firing against a detached node, which warns in dev tools.
          if (self.__autoCloseTimer) clearTimeout(self.__autoCloseTimer);
          self.__autoCloseTimer = setTimeout(function() {
            self.__autoCloseTimer = null;
            if (self.pickerOpen) self.togglePicker();
          }, 250);
        }
      });
    }
  };

  ScentGrid.prototype.disconnectedCallback = function() {
    if (this.__autoCloseTimer) {
      clearTimeout(this.__autoCloseTimer);
      this.__autoCloseTimer = null;
    }
  };

  ScentGrid.prototype.updateVisibility = function() {
    var filtered = [];
    for (var i = 0; i < this.pills.length; i++) {
      if (this.activeFamily === '_all' || this.pills[i].family === this.activeFamily) {
        filtered.push(this.pills[i]);
      }
    }

    // Pin: any checked pill + Unscented (if in filtered set)
    var pinnedSet = {};
    for (var j = 0; j < filtered.length; j++) {
      if (filtered[j].input.checked) pinnedSet[j] = true;
      if (filtered[j].family === 'unscented') pinnedSet[j] = true;
    }

    // Build visible set: all pinned + fill from start until N
    var visibleSet = {};
    var visCount = 0;
    for (var pk in pinnedSet) {
      if (Object.prototype.hasOwnProperty.call(pinnedSet, pk)) {
        visibleSet[pk] = true;
        visCount++;
      }
    }
    for (var k = 0; k < filtered.length && visCount < N_VISIBLE; k++) {
      if (!visibleSet[k]) {
        visibleSet[k] = true;
        visCount++;
      }
    }

    // Apply: each pill is shown if (matches filter) AND (in visible set OR expanded)
    for (var p = 0; p < this.pills.length; p++) {
      var pill = this.pills[p];
      var matchesFilter = this.activeFamily === '_all' || pill.family === this.activeFamily;
      if (!matchesFilter) {
        pill.wrapper.style.display = 'none';
        continue;
      }
      var indexInFiltered = filtered.indexOf(pill);
      var shouldShow = this.expanded || visibleSet[indexInFiltered];
      pill.wrapper.style.display = shouldShow ? '' : 'none';
    }

    // Toggle "More scents" button
    if (this.moreBtn) {
      var hiddenCount = filtered.length - visCount;
      if (hiddenCount > 0) {
        this.moreBtn.style.display = '';
        this.moreBtn.textContent = this.expanded ? 'Show fewer' : 'More scents (' + hiddenCount + ')';
      } else {
        this.moreBtn.style.display = 'none';
      }
    }
  };

  customElements.define('scent-grid', ScentGrid);
})();
